import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#i-908925293__a)\"><circle cx=\"20\" cy=\"20\" r=\"19.5\" stroke=\"#1D1D1D\"></circle><g clip-path=\"url(#i-908925293__b)\"><path fill=\"#1D1D1D\" d=\"M22.89 13.51A6.652 6.652 0 0 0 18 12.03a6.682 6.682 0 0 0-4.5 2.41c-1.13 1.37-1.64 3.12-1.47 4.9a6.682 6.682 0 0 0 2.41 4.5c2.45 2 6 2 8.44 0l.09-.07 4.24 4.24.78-.78-4.24-4.24.07-.09c2.33-2.85 1.91-7.06-.94-9.38l.01-.01Zm-4.21 10.73c-3.06 0-5.56-2.49-5.56-5.56 0-3.07 2.5-5.56 5.56-5.56 3.06 0 5.56 2.49 5.56 5.56a5.56 5.56 0 0 1-5.56 5.56Z\"></path></g></g><defs><clipPath id=\"i-908925293__a\"><path fill=\"#fff\" d=\"M0 0h40v40H0z\"></path></clipPath><clipPath id=\"i-908925293__b\"><path fill=\"#fff\" d=\"M12 12h16v16H12z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "search-icon"}) } }